<template>
  <header class="wec-navbar">
    <div class="wec-navbar__inner">
      <div class="wec-navbar__brand">
        <img
          src="../../assets/img/we-circular/Logo_Interreg_Danube.png"
          alt="Interreg Danube Region"
          class="wec-navbar__logo"
        />
      </div>

      <nav class="wec-navbar__menu">
        <a
          href="/we-circular"
          class="wec-navbar__dropdown-item wec-navbar__dropdown-item--nested"
          @click.prevent="goToHome"
        >
          Home
        </a>

        <a href="/we-circular" class="wec-navbar__dropdown-item" @click.prevent="goToSelectCountry">
          Countries
        </a>

        <div class="wec-navbar__dropdown" @mouseenter="openDropdown('policy')" @mouseleave="closeDropdown">
          <button type="button" class="wec-navbar__link wec-navbar__button">
            Policy landscape
            <span class="wec-navbar__arrow">
              <svg width="10" height="10" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" fill="none" />
              </svg>
            </span>
          </button>

          <div v-if="openMenu === 'policy'" class="wec-navbar__dropdown-menu wec-navbar__dropdown-menu--policy">
            <div class="wec-navbar__dropdown-group">
              <div class="wec-navbar__dropdown-group-title">
                European policy landscape
              </div>

              <router-link
                to="/we-circular/policy-landscape/european-policies"
                class="wec-navbar__dropdown-item wec-navbar__dropdown-item--nested"
              >
                European policies and strategies
              </router-link>

              <router-link
                to="/we-circular/policy-landscape/policy-instruments"
                class="wec-navbar__dropdown-item wec-navbar__dropdown-item--nested"
              >
                Policy instruments and incentives
              </router-link>

              <a href="/we-circular" class="wec-navbar__dropdown-item bold" @click.prevent="goToSelectCountry">
                National policy landscape
              </a>
            </div>
          </div>
        </div>

        <div class="wec-navbar__dropdown" @mouseenter="openDropdown('challenges')" @mouseleave="closeDropdown">
          <button type="button" class="wec-navbar__link wec-navbar__button">
            Challenges
            <span class="wec-navbar__arrow">
              <svg width="10" height="10" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" fill="none" />
              </svg>
            </span>
          </button>

          <div v-if="openMenu === 'challenges'" class="wec-navbar__dropdown-menu">
            <router-link to="/we-circular/europeanchallenges" class="wec-navbar__dropdown-item">
              European challenges
            </router-link>
            <router-link to="/we-circular/regionalchallenges" class="wec-navbar__dropdown-item">
              Regional challenges
            </router-link>
            <router-link to="/we-circular/nationalchallenges" class="wec-navbar__dropdown-item">
              National challenges
            </router-link>
          </div>
        </div>

        <div class="wec-navbar__dropdown" @mouseenter="openDropdown('good')" @mouseleave="closeDropdown">
          <button type="button" class="wec-navbar__link wec-navbar__button">
            Good Practices
            <span class="wec-navbar__arrow">
              <svg width="10" height="10" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" fill="none" />
              </svg>
            </span>
          </button>

          <div v-if="openMenu === 'good'" class="wec-navbar__dropdown-menu">
            <router-link to="/we-circular/goodpractice" class="wec-navbar__dropdown-item">
              Good practices collected by the Project Partners
            </router-link>
            <router-link to="/we-circular/actionplan" class="wec-navbar__dropdown-item">
              Action Plan
            </router-link>
            <router-link to="/we-circular/policyproposals" class="wec-navbar__dropdown-item">
              WE.Circular Policy Proposals
            </router-link>
            <router-link to="/we-circular/circularbusinessmodels" class="wec-navbar__dropdown-item">
              Circular business models
            </router-link>
          </div>
        </div>

        <router-link to="/we-circular/networks" class="wec-navbar__link">
          Networks and Contacts
        </router-link>

        <div class="wec-navbar__dropdown" @mouseenter="openDropdown('capacity')" @mouseleave="closeDropdown">
          <button type="button" class="wec-navbar__link wec-navbar__button">
            Capacity building
            <span class="wec-navbar__arrow">
              <svg width="10" height="10" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" fill="none" />
              </svg>
            </span>
          </button>

          <div v-if="openMenu === 'capacity'" class="wec-navbar__dropdown-menu">
            <router-link to="/we-circular/mentoringtrainingcataloguesdata" class="wec-navbar__dropdown-item">
              Mentoring and Training Catalogues
            </router-link>
            <a
              href="https://digiedu.unsa.ba/login/index.php"
              target="_blank"
              rel="noopener noreferrer"
              class="wec-navbar__dropdown-item"
            >
              WE.Circular Training Materials
            </a>
          </div>
        </div>

        <router-link to="/we-circular/datahub" class="wec-navbar__link">
          Data hub
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'WeCircularNavbar',
  data() {
    return {
      openMenu: null
    }
  },
  methods: {
    openDropdown(menu) {
      this.openMenu = menu
    },

    closeDropdown() {
      this.openMenu = null
    },

    goToHome() {
      this.closeDropdown()
      sessionStorage.removeItem('weCircularSelectedCountry')

      this.$router.push('/we-circular').catch(() => {})

      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      })
    },

    goToSelectCountry() {
      this.closeDropdown()
      sessionStorage.removeItem('weCircularSelectedCountry')

      this.$router
        .push({
          path: '/we-circular',
          hash: '#select-country'
        })
        .catch(() => {})
        .then(() => {
          this.$nextTick(() => {
            setTimeout(() => {
              const el = document.querySelector('#select-country') || document.querySelector('#countries-map')
              if (el) {
                el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                })
              }
            }, 150)
          })
        })
    }
  }
}
</script>

<style scoped>
.wec-navbar__button {
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.wec-navbar {
  width: 100%;
  background: #fff;
}
.wec-navbar__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 22px;
}
.wec-navbar__logo {
  height: 50px;
}

.wec-navbar__menu {
  display: flex;
  gap: 26px;
  align-items: center;
}
.wec-navbar__link {
  color: #244680;
  text-decoration: none;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.wec-navbar__dropdown {
  position: relative;
}
.wec-navbar__dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  padding: 10px 0;
  min-width: 240px;
}

.wec-navbar__dropdown--right .wec-navbar__dropdown-menu {
  left: auto;
  right: 0;
}

.wec-navbar__dropdown-item {
  padding: 10px 16px;
  display: block;
  color: #244680;
}

.wec-navbar__dropdown-group-title {
  padding: 10px 16px;
  font-weight: 600;
  background: #f5f8fc;
}
.bold {
  font-weight: 600;
  padding: 10px 16px;
}
.wec-navbar__dropdown-item--nested {
  padding-left: 30px;
}
</style>
